// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import UsersController from "./users_controller"
application.register("users", UsersController)

import PresentationController from "./presentation_controller"
application.register("presentations", PresentationController)

import SortablePresentationsController from "./sortable_presentations_controller"
application.register("sortable-presentations", SortablePresentationsController)

import DropdownMenuController from "./dropdown_menu_controller"
application.register("dropdown-menu", DropdownMenuController)

import EligibilityDialogController from "./eligibility_dialog_controller"
application.register("eligibility-dialog", EligibilityDialogController)

import ConfirmDialogController from "./confirm_dialog_controller"
application.register("confirm-dialog", ConfirmDialogController)
